import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-media-interactive"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayButton = _resolveComponent("PlayButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overflow-hidden relative w-full", [$props.fullScreen ? 'h-full' : `h-0 ${$options.padding}`]]),
    "data-media-interactive": $props.isSlider ? 'true' : null,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.stopSliderClick && $options.stopSliderClick(...args)))
  }, [
    ($options.showPlaceholder)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $props.placeholder,
          class: "object-cover object-center absolute top-0 left-0 w-full h-full",
          alt: ""
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: $data.videoContainerId,
      class: "object-cover object-center absolute top-0 left-0 w-full h-full"
    }, null, 8, _hoisted_3),
    ($options.showPlaceholder)
      ? (_openBlock(), _createBlock(_component_PlayButton, {
          key: 1,
          "aria-label": $options.$globalLabels.play,
          onClick: $options.play
        }, null, 8, ["aria-label", "onClick"]))
      : _createCommentVNode("", true),
    ($options.showPlaceholder && $props.fullScreen)
      ? _renderSlot(_ctx.$slots, "default", {
          key: 2,
          play: $options.play
        })
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}